/**
 * Capacitor plugin for printing documents, HTML, PDFs, images and web views on iOS and Android.
 * Reference docs used to derive types & behavior:
 *   https://www.npmjs.com/package/@capgo/capacitor-printer
 */

import { CapacitorPluginsBase } from "./capacitorPluginsBase";
import fileHelper from "./fileHelper";
import { Directory } from "./types";
import * as datadog from "@/shared/datadog";

class Printer extends CapacitorPluginsBase {
  /**
   * Presents the printing UI to print PDF documents.
   * @param args - url:string - full url of a pdf file.
   * @param args - name:string - name of the print job. Usage: - Displayed in the system print queue
   * - Shown in print history/logs
   * - May appear in printer status displays
   * - Used as default filename for "Save as PDF" option Platform Behavior:
   * - iOS: Shown in print preview header and activity view
   * - Android: Displayed in print job notification and print queue
   */
  async printPdf (args: {url: string, name: string}) {
    try {
      const downloadFileResult = await fileHelper.downloadFile({ url: args.url, directory: Directory.Temporary, trackProgress: false });
      return await this.plugins.Printer.printPdf({
        name: args.name,
        path: `${String(downloadFileResult.path)}`
      });
    } catch (err) {
      datadog.log("Mobile print error.", err, "error");
      throw err;
    }
  }
}

export default new Printer();